(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("icepath"), require("startlibs"), require("react-redux"), require("redux"), require("recompose"), require("react-router-dom"), require("react-slot-fill"), require("mitt"));
	else if(typeof define === 'function' && define.amd)
		define("statlibs", ["react", "styled-components", "icepath", "startlibs", "react-redux", "redux", "recompose", "react-router-dom", "react-slot-fill", "mitt"], factory);
	else if(typeof exports === 'object')
		exports["statlibs"] = factory(require("react"), require("styled-components"), require("icepath"), require("startlibs"), require("react-redux"), require("redux"), require("recompose"), require("react-router-dom"), require("react-slot-fill"), require("mitt"));
	else
		root["statlibs"] = factory(root["react"], root["styled-components"], root["icepath"], root["startlibs"], root["react-redux"], root["redux"], root["recompose"], root["react-router-dom"], root["react-slot-fill"], root["mitt"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_25__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 57);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AJAX_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setAjaxDefaultError; });
/* harmony export (immutable) */ __webpack_exports__["f"] = makeActionCreator;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reducerCreator; });
/* unused harmony export arrToMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SET_ERRORS = 'SET_ERRORS';
var CLEAR_ERRORS = 'CLEAR_ERRORS';
var REMOVE_LOADING = 'REMOVE_LOADING';
var ADD_LOADING = 'ADD_LOADING';
var AJAX_ERROR = '';
var setAjaxDefaultError = function setAjaxDefaultError(s) {
  return AJAX_ERROR = s;
};

function makeActionCreator(key, reducer, fetcher) {
  var fn = function fn(possiblePayload, possibleActionMeta) {
    return function (dispatch, getState) {
      var payload = (typeof possiblePayload === 'undefined' ? 'undefined' : _typeof(possiblePayload)) !== 'object' || Array.isArray(possiblePayload) || possiblePayload.constructor === Object ? possiblePayload : {};
      var actionMeta = (typeof possibleActionMeta === 'undefined' ? 'undefined' : _typeof(possibleActionMeta)) === 'object' && possibleActionMeta.constructor === Object ? possibleActionMeta : {};
      var meta = _extends({
        _origin: key,
        _payload: payload
      }, actionMeta, {
        actionId: (actionMeta ? actionMeta.actionId : '') || ''
      });
      if (fetcher && !meta._dontFetch) {
        dispatch({ type: CLEAR_ERRORS, payload: meta.actionKey || key + meta.actionId, meta: meta });
        dispatch({ type: ADD_LOADING, meta: meta });
        var fetched = fetcher(payload, actionMeta).then(function (response) {
          if (response.errors) {
            throw response;
          } else {
            dispatch({
              type: key,
              payload: response.success || response,
              meta: _extends({}, meta, response)
            });
          }
          return { success: response.success || response, meta: meta };
        }).catch(function (e) {
          if (e.errors) {
            dispatch({ type: SET_ERRORS, payload: e.errors, meta: meta });
            return { errors: e.errors, meta: meta };
          } else if (e.errorResponse) {
            return { errors: true, response: e.errorResponse, meta: meta };
          } else {
            console.log(e);
            dispatch({ type: SET_ERRORS, payload: { _connection_error_: [AJAX_ERROR] }, meta: _extends({}, meta, { _errorType: e.name }) });
            return { errors: e, meta: meta };
          }
        });
        fetched.then(function (v) {
          return dispatch({ type: REMOVE_LOADING, payload: v, meta: meta });
        });
        return fetched;
      } else {
        dispatch({ type: key, payload: payload, meta: meta });
        return Promise.resolve({ success: payload, meta: meta });
      }
    };
  };
  var actionCreator = fn;
  actionCreator.toString = function () {
    return key;
  };
  actionCreator.reducer = reducer;
  return actionCreator;
}

var reducerCreator = function reducerCreator(initialState, actions) {
  var reducer = actions.reduce(function (acc, action) {
    return _extends({}, acc, _defineProperty({}, action, action.reducer));
  }, {});
  return function (extraReducers) {
    var finalReducer = _extends({}, reducer, extraReducers);
    return function (state, action) {
      return finalReducer[action.type] ? finalReducer[action.type](__WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].chain(state), action.payload, action.meta).value() : state || initialState;
    };
  };
};

function arrToMap(arr) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

  var map = {};
  for (var i = 0; i < arr.length; i++) {
    map[arr[i][key]] = arr[i];
  }
  return map;
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return postFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFetcher; });
/* unused harmony export innerFetcher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closePopups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return openPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lazyLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return removeLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return uiReducer; });
/* harmony export (immutable) */ __webpack_exports__["b"] = arrToMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionHelpers__ = __webpack_require__(6);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var postFetcher = function postFetcher(url, json, extraParams) {
  return innerFetcher(url, json, _extends({
    method: 'POST',
    headers: typeof json === "string" || json.constructor === FormData ? {} : { 'Content-Type': 'application/json; charset=UTF-8' },
    body: typeof json === "string" ? json : json.constructor === FormData ? json : JSON.stringify(json)
  }, extraParams));
};

var addQueryString = function addQueryString(url, obj) {
  return !obj || !Object.keys(obj).length ? url : url + '?' + Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return v !== undefined && v !== null;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
};

var getFetcher = function getFetcher(url, jsonParams, extraParams) {
  return innerFetcher(addQueryString(url, jsonParams), undefined, _extends({
    method: 'GET'
  }, extraParams));
};

var innerFetcher = function innerFetcher(url, json, extraParams) {
  return fetch(url, _extends({
    credentials: 'same-origin'
  }, extraParams)).then(function (e) {
    return e.status >= 400 ? Promise.reject(e.json()) : e.text();
  }).catch(function (e) {
    return e.then ? e.then(function (e) {
      return Promise.reject(e.errors ? e : { errorResponse: e });
    }) : Promise.reject(e);
  }).then(function (e) {
    if (e && typeof e === 'string') {
      try {
        return JSON.parse(e);
      } catch (e) {
        return e;
      }
    } else {
      return e;
    }
  });
};

var formFetch = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('FORM_FETCH', function (s) {
  return s;
}, function (obj, _ref5) {
  var url = _ref5.url;
  return postFetcher(url, obj);
});

var closePopups = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('CLOSE_POPUPS', function () {
  return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"](false);
});
var openPopup = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('OPEN_POPUP', function (chain, id, _ref6) {
  var value = _ref6.value;
  return chain.set(_defineProperty({}, id, value));
});
var popupsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */](false, [closePopups, openPopup]);

var getActionKey = function getActionKey(meta) {
  return meta.actionKey || meta._origin + meta.actionId;
};
var setErrors = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["e" /* SET_ERRORS */], function (chain, errors, meta) {
  return chain.set(getActionKey(meta), errors);
});
var clearErrors = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["c" /* CLEAR_ERRORS */], function (chain, key, _ref7) {
  var path = _ref7.path;
  return chain.update([key], function (errorMap) {
    return !path ? false : __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].filter(errorMap || {}, function (v, k) {
      return k.indexOf(path.join('.')) < 0;
    });
  });
});

var removeError = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('REMOVE_ERROR', function (chain, key, _ref8) {
  var errorKey = _ref8.key,
      value = _ref8.value;
  return chain.on(key, function (errorsChain) {
    return errorsChain.filter(errorKey, function (v) {
      return v !== value || !value;
    }).map(function (errorList) {
      return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].filter(errorList, function (e) {
        return e !== '$' + errorKey;
      });
    }).filter(function (errorList) {
      return errorList.length;
    });
  });
});
var errorsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */]({}, [setErrors, removeError, clearErrors]);

var lazyLoadAction = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */]('LAZY_LOAD', function (chain) {
  return chain;
}, function (url) {
  return postFetcher(url, {});
});
var lazyLoad = function lazyLoad(payload, meta) {
  return lazyLoadAction(payload, _extends({ _dontNotify: true }, meta));
};
lazyLoad.toString = lazyLoadAction.toString;

var addLoading = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["a" /* ADD_LOADING */], function (chain, _, meta) {
  return chain.set(getActionKey(meta), true);
});
var removeLoading = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["f" /* makeActionCreator */](__WEBPACK_IMPORTED_MODULE_2__actionHelpers__["d" /* REMOVE_LOADING */], function (chain, _, meta) {
  return chain.unset(getActionKey(meta));
});
var loadingsReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */]({}, [addLoading, removeLoading]);

var hasFetchedReducer = __WEBPACK_IMPORTED_MODULE_2__actionHelpers__["g" /* reducerCreator */](0, []);

var uiReducer = function uiReducer(extraReducers) {
  return __WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"](_extends({
    openPopup: popupsReducer(),
    errors: errorsReducer(),
    loadings: loadingsReducer(),
    hasFetched: hasFetchedReducer(_defineProperty({}, lazyLoad, function () {
      return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"](Date.now());
    }))
  }, extraReducers));
};

function arrToMap(arr) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "id";

  var map = {};
  for (var i = 0; i < arr.length; i++) {
    map[arr[i][key]] = arr[i];
  }
  map.order = arr.map(function (_) {
    return _[key];
  });
  return map;
}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollWidth; });
/* harmony export (immutable) */ __webpack_exports__["a"] = fixMediaQuery;
var fixed = false;
var scrollWidth = function () {
  if (!window.document) return 0;
  var html = document.documentElement;
  var oldOverflow = html.style.overflowY;
  html.style.overflowY = 'scroll';
  var width = window.innerWidth - html.clientWidth;
  html.style.overflowY = oldOverflow;
  return width;
}();

var fixMediaQueryFn = function fixMediaQueryFn() {

  var fontSize = parseFloat(window.getComputedStyle(document.body).getPropertyValue('font-size'));

  if (scrollWidth > 0) {

    [].slice.call(document.styleSheets).filter(function (styleSheet) {
      return isValidExternal(styleSheet) || isInline(styleSheet);
    }).forEach(function (stylesheet) {
      try {
        [].slice.call(stylesheet.cssRules || stylesheet.media).filter(function (rule) {
          return rule.constructor === window.CSSMediaRule;
        }).forEach(function (rule) {
          rule.media.mediaText = rule.media.mediaText.replace(/m(in|ax)-width:\s*(\d|\.)+(px|em)/gi, function (strA) {
            if (strA.match('px')) {
              return strA.replace(/\d+px/gi, function (strB) {
                return parseInt(strB, 10) + scrollWidth + 'px';
              });
            } else {
              return strA.replace(/\d.+?em/gi, function (strB) {
                return (parseFloat(strB) * fontSize + scrollWidth) / fontSize + 'em';
              });
            }
          });
        });
      } catch (e) {}
    });
  }

  fixed = true;

  function sameOrigin(url) {
    var loc = window.location,
        a = document.createElement('a');
    a.href = url;
    return a.hostname === loc.hostname && a.protocol === loc.protocol;
  }

  function isInline(stylesheet) {
    return stylesheet.ownerNode.constructor === HTMLStyleElement;
  }

  function isValidExternal(stylesheet) {
    return stylesheet.href && sameOrigin(stylesheet.href);
  }
};

function fixMediaQuery() {
  if (fixed || !document || !document.readyState) return;
  if (process.env.NODE_ENV === 'test') {
    return;
  }
  if (document.readyState !== 'loading') {
    fixMediaQueryFn();
  } else {
    document.addEventListener('DOMContentLoaded', fixMediaQueryFn);
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return intToHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return intsToHour; });
/* harmony export (immutable) */ __webpack_exports__["j"] = isSmallDevice;
/* harmony export (immutable) */ __webpack_exports__["g"] = isHighDensity;
/* harmony export (immutable) */ __webpack_exports__["i"] = isRetina;
/* harmony export (immutable) */ __webpack_exports__["h"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["k"] = isTouchDevice;
/* harmony export (immutable) */ __webpack_exports__["a"] = addHttp;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return linkRegex; });
/* harmony export (immutable) */ __webpack_exports__["l"] = isUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = ellipsis;
/* harmony export (immutable) */ __webpack_exports__["p"] = safeNewLineToBr;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return digitsToPattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getClosestOffsetScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return normalizeTouch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return normalizeMouse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fixMediaQuery__ = __webpack_require__(16);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



var intToHour = function intToHour(hour) {
  var autoFill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (hour === undefined) return '';
  if (autoFill) return ('000' + hour.toString()).slice(-4).replace(/(\d\d)(\d\d)/, '$1:$2');
  var h = hour.toString().slice(-4, -2);
  var m = hour.toString().slice(-2);
  if (h) return (parseInt(h, 10) > 23 ? h.slice(1) : h) + ':' + m;
  return m;
};

var intsToHour = function intsToHour(_ref) {
  var open = _ref.open,
      close = _ref.close;
  return intToHour(open) + ' - ' + intToHour(close);
};

function isSmallDevice() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 600;

  var smallDeviceQuery = window.matchMedia ? window.matchMedia('(max-width: ' + (width + __WEBPACK_IMPORTED_MODULE_0__fixMediaQuery__["b" /* scrollWidth */]) + 'px)') : { matches: false };
  return smallDeviceQuery.matches;
}

function isHighDensity() {
  return window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
}

function isRetina() {
  return (window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches) || window.devicePixelRatio && window.devicePixelRatio >= 2) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}

function isMobile() {
  var check = false;
  if (typeof navigator === 'undefined') {
    return false;
  }
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ /])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window['opera']);
  return check;
}

function isTouchDevice() {
  return window.document && 'ontouchstart' in window.document.documentElement;
}

function addHttp(s) {
  s = (s || '').trim();
  if (s.indexOf('http://') === 0 || s.indexOf('https://') === 0) {
    return s;
  } else {
    return 'http://' + s;
  }
}

// export function insertAfter(newNode: HTMLElement,node: HTMLElement) {
//   if (node.nextSibling) {
//     (node.parentNode:any).insertBefore(newNode,node.nextSibling)
//   } else {
//     (node.parentNode:any).appendChild(newNode)
//   }
// }

var protocols = '(^|\\s|\xA0)(https?://)?(www\\.)?';
var subdomains = '([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9]?\\.)*';
var domain = '(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\\.[a-zA-Z]{2,3})';
var resource = '[\xA1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zA-Z0-9-._~:/?#%[\\]@!$&\'()*+,;=]*';
var linkRegex = new RegExp(protocols + subdomains + domain + resource);

function isUrl(url) {
  return linkRegex.test(addHttp(url));
}

function ellipsis() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var length = arguments[1];

  if (str.length > length) {
    var words = str.slice(0, length).split(' ');
    if (str.split(' ').indexOf(words[words.length - 1]) < 0) words = words.slice(0, words.length - 1);
    return words.join(' ') + '...';
  } else return str;
}

function safeNewLineToBr(str) {
  return (str || "").replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/\n+/g, '<br/>');
}

function padGroups(pattern, value) {
  return pattern.split('').reduce(function (_ref2, char, i) {
    var _ref3 = _slicedToArray(_ref2, 2),
        acc = _ref3[0],
        value = _ref3[1];

    if (char === '0') {
      var shouldHave = pattern.slice(i).search(/[^0#?*]/);
      var has = value.slice(i).search(/\D/);
      if (has > 0 && shouldHave > has) {
        return [acc.concat('0'), acc.join('') + '0' + value.slice(i)];
      } else {
        return [acc.concat(value[i]), value];
      }
    } else {
      return [acc.concat(value[i]), value];
    }
  }, [[], value])[0].join('');
}

var digitsToPattern = function digitsToPattern(patternWithLimit, optValue) {
  var value = optValue || "";
  if (patternWithLimit[0] === '>' && Number(patternWithLimit.replace(/^>(\d*).*/g, "$1")) > value.length) return value;
  var pattern = patternWithLimit.replace(/^>\d+/, '');
  var digits = padGroups(pattern, value).replace(/\D/g, '');
  var totalRequired = pattern.split(/[0#]/).length - 1;
  var totalOptional = pattern.split(/[?*]/).length - 1;
  var available = digits.length - totalRequired;

  if (available > 0 && totalOptional > 0) {
    var _i = 0;
    return digitsToPattern(pattern.replace(/\?/g, function () {
      return _i++ < available ? '#' : '';
    }).replace('*', new Array(Math.max(0, available - _i + 1)).join("#")), value);
  }
  var i = 0;
  return pattern.replace(/^>\d*/, '').split('').reduce(function (acc, char) {
    if (!digits[Math.max(i - 1, 0)] || char === '?' || char === '*') return acc;
    if (char === '#' || char === '0') {
      return acc + (digits[i++] || '');
    } else {
      return acc + char;
    }
  }, '');
};

var getClosestOffsetScroll = function getClosestOffsetScroll(node) {
  if (!node) {
    return document.body;
  }
  var overflowY = window.getComputedStyle(node).overflowY;
  var isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';
  if (isScrollable && node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getClosestOffsetScroll(node.offsetParent);
  }
};

var normalizeTouch = function normalizeTouch(fn, endFn) {
  return function (e) {
    var touch = e.touches[0];
    if (e.touches.length > 1) {
      endFn();
    } else {
      fn(e.currentTarget, touch.pageX, touch.pageY, touch.clientX, touch.clientY, e);
    }
  };
};

var normalizeMouse = function normalizeMouse(fn) {
  return function (e) {
    fn(e.currentTarget, e.pageX, e.pageY, e.clientX, e.clientY, e);
  };
};

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return delayableToggles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withToggles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function getTab(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? true : v;
}

var counter = 0;

var state = {};

var delayableToggles = function delayableToggles(Component) {
  var DelayableToggles = function (_React$Component) {
    _inherits(DelayableToggles, _React$Component);

    function DelayableToggles() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, DelayableToggles);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DelayableToggles.__proto__ || Object.getPrototypeOf(DelayableToggles)).call.apply(_ref, [this].concat(args))), _this), _this.state = { closing: {}, reopened: {} }, _this.delayedCloseFunctions = {}, _this.delayedClose = function (milliseconds, k, callback, test) {
        return _this.delayedCloseFunctions[k + '-' + milliseconds.join('-')] = _this.delayedCloseFunctions[k + '-' + milliseconds.join('-')] || function (e) {
          if (test() || _this.state.closing[k]) return;
          if (e) e.stopPropagation();
          _this.setState({
            closing: __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(_this.state.closing, [k], [setTimeout(_this.callNextTick(k, callback, milliseconds.slice(1), 1), Number(milliseconds[0])), 1]),
            reopened: __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].unset(_this.state.reopened, k)
          });
        };
      }, _this.callNextTick = function (k, callback, ticks, i) {
        return function () {
          if (ticks.length) {
            if (ticks[0] === false) {
              _this.cancelClose(k);
            } else if (!isNaN(ticks[0])) {
              _this.setState({
                closing: __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(_this.state.closing, [k], [setTimeout(_this.callNextTick(k, callback, ticks.slice(1), i + 1), Number(ticks[0])), i + 1])
              });
            }
          } else {
            callback();
          }
        };
      }, _this.cancelClose = function (k) {
        if (_this.state.closing[k]) {
          clearTimeout(_this.state.closing[k][0]);
          _this.setState({ closing: __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].unset(_this.state.closing, k), reopened: __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(_this.state.reopened, k, true) });
          return true;
        } else {
          return false;
        }
      }, _this.clearClosed = function (k) {
        if (_this.state.closing[k]) clearTimeout(_this.state.closing[k][0]);
        _this.setState(function (state) {
          return __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"](state).unset(['closing', k]).unset(['reopened', k]).value();
        });
      }, _this.refreshKeyProps = function (newProps, oldProps, keyProps, functions) {
        if (newProps.reopenedToggles !== oldProps.reopenedToggles || newProps.closingToggles !== oldProps.closingToggles) {
          return __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].map(keyProps, function (v, k) {
            if (newProps.reopenedToggles[k] !== oldProps.reopenedToggles[k] || newProps.closingToggles[k] !== oldProps.closingToggles[k]) {
              return Object.create(functions[k], {
                isOpen: { value: v.isOpen },
                reopened: { value: !!newProps.reopenedToggles[k] },
                closing: { value: newProps.closingToggles[k] ? newProps.closingToggles[k][1] : false }
              });
            } else {
              return v;
            }
          });
        } else {
          return keyProps;
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DelayableToggles, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, this.props, {
          delayedClose: this.delayedClose,
          refreshKeyProps: this.refreshKeyProps,
          cancelDelayedClose: this.cancelClose,
          clearDelayedClose: this.clearClosed,
          closingToggles: this.state.closing,
          reopenedToggles: this.state.reopened
        }));
      }
    }]);

    return DelayableToggles;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  return DelayableToggles;
};

var withToggles = function withToggles() {
  for (var _len2 = arguments.length, names = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    names[_key2] = arguments[_key2];
  }

  return function (Component) {
    var _class2;

    var Toggleable = delayableToggles(_class2 = function (_React$Component2) {
      _inherits(Toggleable, _React$Component2);

      function Toggleable(props) {
        _classCallCheck(this, Toggleable);

        var _this2 = _possibleConstructorReturn(this, (Toggleable.__proto__ || Object.getPrototypeOf(Toggleable)).call(this, props));

        _this2.keys = names;
        _this2.id = Component.name + '-' + _this2.keys.join(',') + '-' + counter++;
        state = __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(state, _this2.id, _this2.keys.map(function (k) {
          return _this2.props[k + 'IsOpen'] || false;
        }));
        _this2.functions = _this2.keys.reduce(function (acc, k, i) {
          return _extends({}, acc, _defineProperty({}, k, {
            open: function open() {
              var possibleTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

              if (!_this2.props.cancelDelayedClose(k) || possibleTab !== true) {
                if (state[_this2.id][i] !== getTab(possibleTab)) _this2.functions[k].toggle(possibleTab);
              }
            },
            close: function close() {
              if (state[_this2.id][i] !== false) _this2.functions[k].toggle(false);
            },
            closeAfter: function closeAfter() {
              for (var _len3 = arguments.length, milliseconds = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                milliseconds[_key3] = arguments[_key3];
              }

              return _this2.props.delayedClose(milliseconds, k, _this2.functions[k].close, _this2.functions[k].isClosed);
            },
            isClosed: function isClosed() {
              return state[_this2.id][i] === false;
            },
            toggle: function toggle() {
              var possibleTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

              var tab = getTab(possibleTab);
              var value = state[_this2.id][i] !== tab ? tab : false;
              state = __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(state, [_this2.id, i], value);
              if (value === false) {
                _this2.props.clearDelayedClose(k);
              }
              _this2.keyProps = __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(_this2.keyProps, [k], Object.create(_this2.functions[k], {
                isOpen: { value: value },
                reopened: { value: false },
                closing: { value: false }
              }));
              _this2.forceUpdate();
            }
          }));
        }, {});
        _this2.keyProps = __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].map(_this2.functions, function (v, k, i) {
          return Object.create(v, {
            isOpen: { value: state[_this2.id][_this2.keys.indexOf(k)] },
            reopened: { value: false },
            closing: { value: false }
          });
        });
        return _this2;
      }

      _createClass(Toggleable, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
          this.keyProps = this.props.refreshKeyProps(newProps, this.props, this.keyProps, this.functions);
          //   if (this.props.outer !== newProps.outer) {
          //     const newToggled = newProps.outer.map((v,i)=>this.props.outer[i] !== v ? v : newProps.inner[i]);
          //     this.props.setToggles(this.props.id,newToggled)
          //   }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              delayedClose = _props.delayedClose,
              refreshKeyProps = _props.refreshKeyProps,
              cancelDelayedClose = _props.cancelDelayedClose,
              clearDelayedClose = _props.clearDelayedClose,
              closingToggles = _props.closingToggles,
              reopenedToggles = _props.reopenedToggles,
              rest = _objectWithoutProperties(_props, ['delayedClose', 'refreshKeyProps', 'cancelDelayedClose', 'clearDelayedClose', 'closingToggles', 'reopenedToggles']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, rest, this.keyProps));
        }
      }]);

      return Toggleable;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class2;

    return Toggleable;
  };
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withGroupEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mitt__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mitt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mitt__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var withGroupEvent = function withGroupEvent(Component) {
  var emitter = __WEBPACK_IMPORTED_MODULE_1_mitt___default.a();

  var WithGroupEvent = function (_React$Component) {
    _inherits(WithGroupEvent, _React$Component);

    function WithGroupEvent() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WithGroupEvent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithGroupEvent.__proto__ || Object.getPrototypeOf(WithGroupEvent)).call.apply(_ref, [this].concat(args))), _this), _this.events = {}, _this.processEvent = function (type, event) {
        (_this.events[type] || []).forEach(function (c) {
          return c(event);
        });
      }, _this.groupEventProps = {
        on: function on(type, callback) {
          _this.events[type] = (_this.events[type] || []).concat(callback);
        },
        off: function off(type, callback) {
          _this.events[type] = (_this.events[type] || []).filter(function (e) {
            return e !== callback;
          });
        },
        emit: emitter.emit
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WithGroupEvent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        emitter.on('*', this.processEvent);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        emitter.off('*', this.processEvent);
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, this.props, { groupEvent: this.groupEventProps }));
      }
    }]);

    return WithGroupEvent;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  return WithGroupEvent;
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withUID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose__);


var id = 1;

var withUID = __WEBPACK_IMPORTED_MODULE_0_recompose__["withPropsOnChange"]('UID', function (_ref) {
  var UID = _ref.UID;
  return { UID: UID !== undefined ? UID : id++ };
});

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hocs_withToggles__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_fetchConnect__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_withDialogError__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_withGroupEvent__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_withUID__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_WithPortal__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hocs_withPopupToggles__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hocs_withLayers__ = __webpack_require__(62);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withPopupToggles", function() { return __WEBPACK_IMPORTED_MODULE_6__hocs_withPopupToggles__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withLayers", function() { return __WEBPACK_IMPORTED_MODULE_7__hocs_withLayers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WithPortal", function() { return __WEBPACK_IMPORTED_MODULE_5__hocs_WithPortal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withUID", function() { return __WEBPACK_IMPORTED_MODULE_4__hocs_withUID__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withGroupEvent", function() { return __WEBPACK_IMPORTED_MODULE_3__hocs_withGroupEvent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withDialogError", function() { return __WEBPACK_IMPORTED_MODULE_2__hocs_withDialogError__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouteTo", function() { return __WEBPACK_IMPORTED_MODULE_1__hocs_fetchConnect__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pushState", function() { return __WEBPACK_IMPORTED_MODULE_1__hocs_fetchConnect__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pushFetchedState", function() { return __WEBPACK_IMPORTED_MODULE_1__hocs_fetchConnect__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fetchConnect", function() { return __WEBPACK_IMPORTED_MODULE_1__hocs_fetchConnect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delayableToggles", function() { return __WEBPACK_IMPORTED_MODULE_0__hocs_withToggles__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withToggles", function() { return __WEBPACK_IMPORTED_MODULE_0__hocs_withToggles__["b"]; });











/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pushFetch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pushState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pushFetchedState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return withRouteTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchConnect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var getLocation = function getLocation() {
  return window.location ? window.location.pathname + window.location.search : ":(";
};

var firstLocation = getLocation();

var stateHolder = {};
var fetchHolder = {};
var fetchedState = [];
var pushFetch = function pushFetch(state, url) {
  return fetchHolder[url || getLocation()] = state;
};
var pushState = function pushState(state) {
  return stateHolder[getLocation()] = state;
};
var pushFetchedState = function pushFetchedState(s) {
  return fetchedState = fetchedState.concat([s]);
};

var contextType = _extends({}, __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"].contextTypes, { startlibs: function startlibs() {
    return null;
  } });

var getState = function getState() {
  return function (_, getState) {
    return getState();
  };
};

var firstOrNull = function firstOrNull(v) {
  return v.length ? v[0] : null;
};

var findRoute = function findRoute(routes, to) {
  return firstOrNull(routes.filter(function (_) {
    return _[0].test ? _[0].test(to) : _[0] === to;
  }).slice(0, 1).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        test = _ref2[0],
        url = _ref2[1];

    return test.exec ? to.replace(test, url) : url;
  }));
};

var unconnectedWithRouteTo = function unconnectedWithRouteTo(Component) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    _inherits(WithLinkGoTo, _React$Component);

    function WithLinkGoTo() {
      var _ref3;

      var _temp, _this, _ret;

      _classCallCheck(this, WithLinkGoTo);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = WithLinkGoTo.__proto__ || Object.getPrototypeOf(WithLinkGoTo)).call.apply(_ref3, [this].concat(args))), _this), _this.goTo = function (to) {
        var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        pushState(_this.props.getState());
        var history = _this.context.router.history;

        var route = findRoute(_this.context.startlibs.fetchRoutes, to);

        route && _this.props.addLoading({}, { _origin: __WEBPACK_IMPORTED_MODULE_3_startlibs__["lazyLoad"] });

        return route ? __WEBPACK_IMPORTED_MODULE_3_startlibs__["getFetcher"](route).then(function (e) {
          return pushFetch(e, to);
        }).then(function () {
          return _this.props.removeLoading({}, { _origin: __WEBPACK_IMPORTED_MODULE_3_startlibs__["lazyLoad"] });
        }).then(function (e) {
          return replace ? history.replace(to) : history.push(to);
        }) : _this.props.lazyLoad(to, { reduce: function reduce(chain) {
            return chain;
          } }).then(function (_ref4) {
          var errors = _ref4.errors,
              success = _ref4.success;

          if (errors) {
            throw errors;
          } else {
            pushFetchedState(success);
            if (replace) {
              history.replace(to);
            } else {
              history.push(to);
            }
          }
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WithLinkGoTo, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            lazyLoad = _props.lazyLoad,
            getState = _props.getState,
            addLoading = _props.addLoading,
            removeLoading = _props.removeLoading,
            props = _objectWithoutProperties(_props, ['lazyLoad', 'getState', 'addLoading', 'removeLoading']);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, props, { routeTo: this.goTo }));
      }
    }]);

    return WithLinkGoTo;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.contextTypes = contextType, _temp2;
};

var withRouteTo = function withRouteTo(component) {
  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"](undefined, { lazyLoad: __WEBPACK_IMPORTED_MODULE_3_startlibs__["lazyLoad"], getState: getState, addLoading: __WEBPACK_IMPORTED_MODULE_3_startlibs__["addLoading"], removeLoading: __WEBPACK_IMPORTED_MODULE_3_startlibs__["removeLoading"] })(unconnectedWithRouteTo(component));
};

var fetchConnect = function fetchConnect(stateToProps, dispatchToProps, propKey) {
  return function (Component) {
    var _class2, _temp4;

    return __WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"](stateToProps, typeof dispatchToProps === 'function' ? function (dispatcher, ownProps) {
      return _extends({ lazyLoad: __WEBPACK_IMPORTED_MODULE_3_startlibs__["lazyLoad"], getState: getState }, dispatchToProps(dispatcher, ownProps));
    } : _extends({ lazyLoad: __WEBPACK_IMPORTED_MODULE_3_startlibs__["lazyLoad"], addLoading: __WEBPACK_IMPORTED_MODULE_3_startlibs__["addLoading"], removeLoading: __WEBPACK_IMPORTED_MODULE_3_startlibs__["removeLoading"], getState: getState }, dispatchToProps))((_temp4 = _class2 = function (_React$Component2) {
      _inherits(_class2, _React$Component2);

      function _class2() {
        var _ref5;

        var _temp3, _this2, _ret2;

        _classCallCheck(this, _class2);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp3 = (_this2 = _possibleConstructorReturn(this, (_ref5 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref5, [this].concat(args))), _this2), _this2.state = { loaded: false }, _this2.checkFetchedUrl = function () {
          var fetchedUrl = fetchHolder[getLocation()];
          if (fetchedUrl) {
            if (_this2.props.connectFetcher) {
              _this2.props.connectFetcher(fetchedUrl, { _dontFetch: true, ownProps: _this2.props }).then(function () {
                fetchedState = [];
                pushState(_this2.props.getState());
                _this2.setState({ loaded: true });
              });
            } else {
              _this2.setState({ loaded: true, fetched: fetchedUrl });
            }
            return true;
          }
          return false;
        }, _temp3), _possibleConstructorReturn(_this2, _ret2);
      }

      _createClass(_class2, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this3 = this;

          window.scrollTo(0, 0);
          if (this.props.dontFetch) {
            this.setState({ loaded: true });
            return;
          }

          if (this.checkFetchedUrl()) {
            return;
          }
          var route = findRoute(this.context.startlibs.fetchRoutes, getLocation());
          if (route || propKey) {
            this.props.addLoading({}, { _origin: __WEBPACK_IMPORTED_MODULE_3_startlibs__["lazyLoad"] });
            __WEBPACK_IMPORTED_MODULE_3_startlibs__["getFetcher"](route || getLocation()).then(function (e) {
              return pushFetch(e, getLocation());
            }).then(function () {
              return _this3.props.removeLoading({}, { _origin: __WEBPACK_IMPORTED_MODULE_3_startlibs__["lazyLoad"] });
            }).then(this.checkFetchedUrl);
            return;
          }

          var fetcher = this.props.connectFetcher || this.props.lazyLoad;
          if (fetchedState.length) {
            fetcher(fetchedState[fetchedState.length - 1], { _dontFetch: true, ownProps: this.props }).then(function () {
              fetchedState = [];
              pushState(_this3.props.getState());
              _this3.setState({ loaded: true });
            });
            return;
          }
          var action = this.context.router.history.action;
          var state = stateHolder[getLocation()];
          var reduxState = this.props.getState();
          var firstLoad = action === 'POP' && !state && !reduxState.appUI.hasFetched && firstLocation === getLocation();
          if (firstLoad) {
            pushState(reduxState);
            this.setState({ loaded: true });
            return;
          }
          var promise = state ? fetcher(stateHolder[getLocation()], { _dontFetch: true, reduce: function reduce(chain, newState) {
              return chain.set([], newState);
            } }).then(function () {
            return _this3.setState({ loaded: true });
          }) : Promise.resolve();
          promise.then(function () {
            return fetcher(getLocation());
          }).then(function () {
            _this3.setState({ loaded: true });
            pushState(_this3.props.getState());
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var _props2 = this.props,
              lazyLoad = _props2.lazyLoad,
              getState = _props2.getState,
              props = _objectWithoutProperties(_props2, ['lazyLoad', 'getState']);

          var fetched = this.state.fetched ? _defineProperty({}, propKey || "fetched", this.state.fetched) : {};
          return this.state.loaded ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, fetched, props, { refreshFetchedState: this.checkFetchedUrl })) : null;
        }
      }]);

      return _class2;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.contextTypes = contextType, _temp4));
  };
};


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withDialogError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var withDialogError = function withDialogError(Dialog) {
  var ErrorBoundedComponent = function ErrorBoundedComponent(props, _ref) {
    var __internals = _ref.startlibs.__internals;

    var ErrorBoundary = __internals('ErrorBoundary');
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ErrorBoundary,
      { Error: props.Error || __internals('DialogError'), closeDialog: props.closeDialog },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dialog, props)
    );
  };
  ErrorBoundedComponent.contextTypes = { startlibs: function startlibs() {
      return null;
    } };
  return ErrorBoundedComponent;
};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WithPortal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slot_fill__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slot_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slot_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_index__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  top:0;\n  left:0;\n  padding: 0 !important;\n  position: absolute;    \n'], ['\n  top:0;\n  left:0;\n  padding: 0 !important;\n  position: absolute;    \n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  position: absolute;\n  width: ', 'px;\n  height: ', 'px;\n  ', '    \n'], ['\n  background-color: #fff;\n  position: absolute;\n  width: ', 'px;\n  height: ', 'px;\n  ', '    \n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }








var Placeholder = __WEBPACK_IMPORTED_MODULE_2_styled_components___default.a.span(_templateObject);

var HORIZONTAL_MAPPING = ['left', 'center', 'right'];
var VERTICAL_MAPPING = ['top', 'center', 'bottom'];

function getPosition(origin, offset, max, originSize, selfSize, originalAlignment, selfAlignment, onCollision, mapping) {

  // 0 pra left ou top, 1/2 pra center, 1 pra right ou bottom
  var originDiff = originSize * (mapping.indexOf(originalAlignment) / 2);
  // 0 pra left ou top, -1/2 pra center, -1 pra right ou bottom
  var selfDiff = -(selfSize * (mapping.indexOf(selfAlignment) / 2));

  var newPosition = origin + selfDiff + originDiff + offset;

  var collision = Math.max(-newPosition, newPosition + selfSize - max);

  if (collision > 0 && onCollision !== 'none') {
    if (onCollision.indexOf('flip') >= 0) {
      var flippedPosition = getPosition(origin, -offset, max, originSize, selfSize, originalAlignment, selfAlignment, onCollision.indexOf('fit') >= 0 ? 'fit' : 'none', mapping.slice().reverse());
      var flippedCollision = Math.max(-flippedPosition[0], flippedPosition[0] + selfSize - max);
      return collision < flippedCollision ? [newPosition, 'none'] : [flippedPosition[0], flippedPosition[1] === 'fit' ? 'flipfit' : 'flip'];
    } else {
      return newPosition < 0 ? [0, 'fitted'] : [newPosition - collision, collision !== 0 ? 'fit' : 'none'];
    }
  } else {
    return [newPosition, 'none'];
  }
}

var arrowShadow = {
  top: 'box-shadow: -2px -2px 2px -2px rgba(0,0,0,.5);',
  right: 'box-shadow: 2px 2px -2px 2px rgba(0,0,0,.5);',
  bottom: 'box-shadow: 2px 2px -2px 2px rgba(0,0,0,.5);',
  left: 'box-shadow: 2px 2px -2px 2px rgba(0,0,0,.5);'
};

var translate = function translate(position, offset) {
  return (position === "left" ? "-50%" : position === "right" ? "50%" : offset) + "," + (position === "top" ? "-50%" : position === "bottom" ? "50%" : offset);
};

var ARROW_DEFAULT_SIZE = 14;

var Arrow = __WEBPACK_IMPORTED_MODULE_2_styled_components___default.a.div(_templateObject2, ARROW_DEFAULT_SIZE, ARROW_DEFAULT_SIZE, function (props) {
  return '\n    transform: translate(' + translate(props.arrowSide, props.arrowOffset.indexOf("top") >= 0 || props.arrowOffset.indexOf("left") >= 0 ? "-50%" : "50%") + ') rotate(45deg);\n    ' + props.arrowSide + ':0;\n    ' + arrowShadow[props.arrowSide] + '\n    ' + props.arrowOffset + '  \n  ';
});

var WithPortal = function WithPortal(slot) {
  var useLayers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (Component) {
    var _class, _temp2;

    return _temp2 = _class = function (_React$PureComponent) {
      _inherits(Portal, _React$PureComponent);

      function Portal() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Portal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.state = { arrowOffset: "" }, _this.getDialogLayers = function () {
          return (__WEBPACK_IMPORTED_MODULE_5_icepath__["ice"].get(_this.context.startlibs, ['__withLayers__internal', 'Dialog']) || []).length;
        }, _this.setPosition = function (popup) {
          if (!popup) {
            _this.popup = popup;
            return;
          }
          if (!popup.style) return;
          _this.popup = popup;
          if (!_this.placeholder) {
            _this.doResize = true;
            return;
          }
          var usingLayer = useLayers && _this.getDialogLayers() > 0;
          var scrollOwner = usingLayer ? __WEBPACK_IMPORTED_MODULE_4__lib_index__["d" /* getClosestOffsetScroll */](popup.offsetParent) : { scrollTop: 0, scrollLeft: 0 };
          var scrollY = scrollOwner.scrollTop || window.pageYOffset;
          var scrollX = scrollOwner.scrollLeft || window.pageXOffset;

          var _this$placeholder$get = _this.placeholder.getBoundingClientRect(),
              leftPlusBorder = _this$placeholder$get.left,
              topPlusBorder = _this$placeholder$get.top;

          var _window$getComputedSt = window.getComputedStyle(_this.placeholder.offsetParent),
              borderLeftWidth = _window$getComputedSt.borderLeftWidth,
              borderTopWidth = _window$getComputedSt.borderTopWidth;

          var left = leftPlusBorder - parseInt(borderLeftWidth, 10) - (usingLayer ? window.scrollX : 0);
          var top = topPlusBorder - parseInt(borderTopWidth, 10) - (usingLayer ? window.scrollY : 0);
          var _ref2 = _this.placeholder.offsetParent,
              parentOffsetWidth = _ref2.offsetWidth,
              parentOffsetHeight = _ref2.offsetHeight;
          var popupOffsetWidth = popup.offsetWidth,
              popupOffsetHeight = popup.offsetHeight;
          var _this$props = _this.props,
              fixed = _this$props.fixed,
              offset = _this$props.offset,
              my = _this$props.my,
              at = _this$props.at,
              onBottom = _this$props.bottom,
              onLeft = _this$props.left,
              onRight = _this$props.right,
              onTop = _this$props.top,
              arrow = _this$props.arrow,
              fill = _this$props.fill,
              onCollision = _this$props.onCollision;

          var _concat$join$split$ma = [].concat(offset).join(' ').split(' ').map(function (_) {
            return Number(_ || 0);
          }),
              _concat$join$split$ma2 = _slicedToArray(_concat$join$split$ma, 2),
              offsetX = _concat$join$split$ma2[0],
              offsetY = _concat$join$split$ma2[1];

          var simplePositioning = [onTop, onRight, onBottom, onLeft].map(function (_) {
            return _ === true ? "center" : _;
          });
          var simplePositioningIndex = simplePositioning.findIndex(function (_) {
            return _;
          });
          !document.body ? process.env.NODE_ENV !== 'production' ? __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default.a(false, '') : __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_invariant___default.a(false) : void 0;
          var bodyWidth = document.body.offsetWidth - (usingLayer ? parseInt(getComputedStyle(document.body).paddingRight, 10) : 0);
          var windowHeight = window.innerHeight;

          var _onCollision$split = onCollision.split(' '),
              _onCollision$split2 = _slicedToArray(_onCollision$split, 2),
              verticalCollision = _onCollision$split2[0],
              horizontalCollision = _onCollision$split2[1];

          var _replace$split = [my, 'bottom $', '$ left', 'top $', '$ right'][simplePositioningIndex + 1].replace("$", simplePositioning[simplePositioningIndex]).split(' '),
              _replace$split2 = _slicedToArray(_replace$split, 2),
              verticalMy = _replace$split2[0],
              horizontalMy = _replace$split2[1];

          var _replace$split3 = [at, 'top $', '$ right', 'bottom $', '$ left'][simplePositioningIndex + 1].replace("$", simplePositioning[simplePositioningIndex]).split(' '),
              _replace$split4 = _slicedToArray(_replace$split3, 2),
              verticalAt = _replace$split4[0],
              horizontalAt = _replace$split4[1];

          var _getPosition = getPosition(left, offsetX, bodyWidth, parentOffsetWidth, fill ? parentOffsetWidth : popupOffsetWidth, horizontalAt, horizontalMy, horizontalCollision, HORIZONTAL_MAPPING),
              _getPosition2 = _slicedToArray(_getPosition, 2),
              processedLeft = _getPosition2[0],
              collisionH = _getPosition2[1];

          var _getPosition3 = getPosition(top, offsetY, windowHeight, parentOffsetHeight, popupOffsetHeight, verticalAt, verticalMy, verticalCollision, VERTICAL_MAPPING),
              _getPosition4 = _slicedToArray(_getPosition3, 2),
              processedTop = _getPosition4[0],
              collisionV = _getPosition4[1];

          var flippedV = collisionV.indexOf('flip') >= 0;
          var flippedH = collisionH.indexOf('flip') >= 0;

          //arrow
          var arrowSide = Math.abs(VERTICAL_MAPPING.indexOf(verticalMy) - VERTICAL_MAPPING.indexOf(verticalAt)) === 2 ? flippedV ? verticalAt : verticalMy : Math.abs(HORIZONTAL_MAPPING.indexOf(horizontalMy) - HORIZONTAL_MAPPING.indexOf(horizontalAt)) === 2 ? flippedH ? horizontalAt : horizontalMy : '';
          var arrowElement = popup.querySelector(".ARROW");
          var arrowOnVerticalSide = arrowSide === "left" || arrowSide === "right";
          var arrowSize = arrowElement ? popup.querySelector(".ARROW").getBoundingClientRect()[arrowOnVerticalSide ? 'height' : 'width'] : ARROW_DEFAULT_SIZE * Math.sqrt(2);

          var _ref3 = arrowOnVerticalSide ? _this.processArrow(arrow, arrowSize, arrowOnVerticalSide, parentOffsetHeight, popupOffsetHeight, processedTop - top, flippedV) : _this.processArrow(arrow, arrowSize, arrowOnVerticalSide, parentOffsetWidth, popupOffsetWidth, processedLeft - left, flippedV),
              _ref4 = _slicedToArray(_ref3, 2),
              arrowOffset = _ref4[0],
              popupArrowOffset = _ref4[1];

          popup.style.top = processedTop + (arrowOnVerticalSide ? popupArrowOffset : 0) + (fixed ? 0 : scrollY) + 'px';
          popup.style.left = processedLeft + (arrowOnVerticalSide ? 0 : popupArrowOffset) + (fixed ? 0 : scrollX) + 'px';

          _this.setState({
            atTop: verticalAt === 'top' && !flippedV || verticalAt === 'bottom' && flippedV,
            atBottom: verticalAt === 'bottom' && !flippedV || verticalAt === 'top' && flippedV,
            atLeft: horizontalAt === 'left' && !flippedH || verticalAt === 'right' && flippedH,
            atRight: horizontalAt === 'right' && !flippedH || verticalAt === 'left' && flippedH,
            arrowSide: arrowSide,
            arrowOffset: arrowOffset
          });

          if (fill) {
            popup.style.width = parentOffsetWidth + 'px';
          }
          if (_this.props.fixed) {
            popup.style.position = 'fixed';
          }
        }, _this.resizeEvent = function () {
          return _this.setPosition(_this.popup);
        }, _this.processArrow = function (arrow, arrowSize, onVerticalSide, arrowContainerWidth, popupSize, deltaPopupPosition, flipped) {
          if (!arrow) {
            return ["", 0];
          }
          // arrow
          var margin = _this.props.arrowPadding + arrowSize / 2;

          var _replace$split5 = (arrow === true ? "50%" : arrow).replace(/(-)?(\d+%)?\s?(-?\d+)?/, "$1:$2:$3").split(":"),
              _replace$split6 = _slicedToArray(_replace$split5, 3),
              invertDirection = _replace$split6[0],
              percent = _replace$split6[1],
              px = _replace$split6[2];

          var invertAndFlipDirection = flipped ? !invertDirection : invertDirection;
          var arrowPosition = onVerticalSide ? invertAndFlipDirection ? "bottom" : "top" : invertAndFlipDirection ? "right" : "left";
          var offset = arrowPosition === "left" || arrowPosition === "top" ? -deltaPopupPosition : deltaPopupPosition;
          var arrowInitialPos = parseInt(percent || 0, 10) * arrowContainerWidth / 100 + parseInt(px || 0, 10);
          var offsetedPosition = Math.min(Math.max(arrowInitialPos, 0), arrowContainerWidth) + offset;
          var popupDelta = offsetedPosition < margin ? offsetedPosition - margin : offsetedPosition > popupSize - margin ? +margin - offsetedPosition : 0;
          var arrowOffset = arrowPosition + ":" + (offsetedPosition - popupDelta) + "px;";
          return [arrowOffset, popupDelta];
        }, _this.setPlaceholder = function (el) {
          _this.placeholder = el;
          if (el && _this.doResize) {
            _this.doResize = false;
            _this.resizeEvent();
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(Portal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          window.addEventListener('portalReposition', this.resizeEvent);
          window.addEventListener('stepResize', this.resizeEvent);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          window.removeEventListener('portalReposition', this.resizeEvent);
          window.removeEventListener('stepResize', this.resizeEvent);
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              fill = _props.fill,
              arrow = _props.arrow,
              Arrow = _props.Arrow,
              rest = _objectWithoutProperties(_props, ['fill', 'arrow', 'Arrow']);

          var _state = this.state,
              arrowSide = _state.arrowSide,
              arrowOffset = _state.arrowOffset;

          var inner = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Component,
            _extends({}, rest, this.state, { ref: this.setPosition, innerRef: this.setPosition }),
            arrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Arrow, { className: 'ARROW', arrowOffset: arrowOffset, arrowSide: arrowSide }),
            this.props.children
          );
          var slotName = this.props.slot || (!useLayers || this.getDialogLayers() === 0 ? slot : slot + '-' + (this.getDialogLayers() - 1));
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Placeholder,
            { innerRef: this.setPlaceholder },
            this.props.inline ? inner : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_slot_fill__["Fill"],
              { name: slotName },
              inner
            )
          );
        }
      }]);

      return Portal;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class.contextTypes = { startlibs: function startlibs() {
        return null;
      } }, _class.defaultProps = {
      my: 'top right',
      offset: '0 0', // x y
      at: 'bottom right',
      onCollision: 'flip flip',
      Arrow: Arrow,
      arrowPadding: 10
    }, _temp2;
  };
};

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withPopupToggles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withToggles__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_UiReducers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var toKey = function toKey(name) {
  return name.slice(0, 1).toUpperCase() + name.slice(1);
};
var counter = 0;
var uniqueState = function uniqueState(componentName, names) {
  return function () {
    var keys = names.map(toKey);
    var id = componentName + '-' + keys.join(',') + '-' + counter++;
    return function (state) {
      return { isOpen: state.appUI.openPopup[id] || false, id: id };
    };
  };
};

function getValue(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? true : v;
}

var withPopupToggles = function withPopupToggles() {
  for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  return function (Component) {
    var _dec, _class;

    var PopupToggle = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"](uniqueState(Component.name, names), function (dispatch) {
      return {
        openPopup: function openPopup(id, value) {
          return dispatch(__WEBPACK_IMPORTED_MODULE_3__reducers_UiReducers__["h" /* openPopup */](id, { value: value }));
        }
      };
    }), __WEBPACK_IMPORTED_MODULE_2__withToggles__["a" /* delayableToggles */](_class = _dec(_class = function (_React$Component) {
      _inherits(PopupToggle, _React$Component);

      function PopupToggle(props) {
        _classCallCheck(this, PopupToggle);

        var _this = _possibleConstructorReturn(this, (PopupToggle.__proto__ || Object.getPrototypeOf(PopupToggle)).call(this, props));

        _this.keys = names;

        _this.functions = _this.keys.reduce(function (acc, k, i) {
          return _extends({}, acc, _defineProperty({}, k, {
            open: function open(e) {
              var v = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

              if (!_this.props.cancelDelayedClose(k) || v !== true) {
                if (typeof _this.props.isOpen === 'boolean' ? true : _this.props.isOpen[k] !== getValue(v)) _this.functions[k].toggle(e, v);
              }
            },
            close: function close(e) {
              if (typeof _this.props.isOpen === 'boolean' ? false : _this.props.isOpen[k] !== undefined) _this.functions[k].toggle(e, false);
            },
            closeAfter: function closeAfter() {
              for (var _len2 = arguments.length, milliseconds = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                milliseconds[_key2] = arguments[_key2];
              }

              return _this.props.delayedClose(milliseconds, k, _this.functions[k].close, _this.functions[k].isClosed);
            },
            isClosed: function isClosed() {
              return typeof _this.props.isOpen === 'boolean' ? true : _this.props.isOpen[k] === undefined;
            },
            toggle: function toggle(e) {
              var v = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

              if (e) e.stopPropagation();
              var value = getValue(v);
              var isClosed = typeof _this.props.isOpen === 'boolean' ? true : _this.props.isOpen[k] !== getValue(v);
              _this.props.clearDelayedClose(k);
              _this.props.openPopup(_this.props.id, _defineProperty({}, k, isClosed ? value : false));
            }
          }));
        }, {});
        _this.keyProps = __WEBPACK_IMPORTED_MODULE_4_icepath__["ice"].map(_this.functions, function (v, k) {
          return Object.create(v, {
            isOpen: { value: props['is' + toKey(k) + 'Open'] || false },
            closing: { value: false },
            reopened: { value: false }
          });
        });
        return _this;
      }

      _createClass(PopupToggle, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var isOpen = __WEBPACK_IMPORTED_MODULE_4_icepath__["ice"].map(this.keyProps, function (v) {
            return v.isOpen;
          });
          if (Object.values(isOpen).find(function (v) {
            return v !== false;
          })) {
            this.props.openPopup(this.props.id, isOpen);
          }
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
          var _this2 = this;

          if (newProps.isOpen !== this.props.isOpen) {
            if (!newProps.isOpen) {
              this.keyProps = __WEBPACK_IMPORTED_MODULE_4_icepath__["ice"].map(this.keyProps, function (v, k) {
                return Object.create(_this2.functions[k], {
                  isOpen: { value: false },
                  closing: { value: !!newProps.closingToggles[k] },
                  reopened: { value: !!newProps.reopenedToggles[k] }
                });
              });
            } else {
              this.keyProps = __WEBPACK_IMPORTED_MODULE_4_icepath__["ice"].map(this.keyProps, function (v, k) {
                return Object.create(_this2.functions[k], {
                  isOpen: { value: newProps.isOpen[k] !== undefined ? newProps.isOpen[k] : false },
                  closing: { value: !!newProps.closingToggles[k] },
                  reopened: { value: !!newProps.reopenedToggles[k] }
                });
              });
            }
          } else {
            this.keyProps = this.props.refreshKeyProps(newProps, this.props, this.keyProps, this.functions);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              isOpen = _props.isOpen,
              id = _props.id,
              openPopup = _props.openPopup,
              refreshKeyProps = _props.refreshKeyProps,
              delayedClose = _props.delayedClose,
              cancelDelayedClose = _props.cancelDelayedClose,
              clearDelayedClose = _props.clearDelayedClose,
              closingToggles = _props.closingToggles,
              reopenedToggles = _props.reopenedToggles,
              rest = _objectWithoutProperties(_props, ['isOpen', 'id', 'openPopup', 'refreshKeyProps', 'delayedClose', 'cancelDelayedClose', 'clearDelayedClose', 'closingToggles', 'reopenedToggles']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, rest, { popupTogglesId: id }, this.keyProps));
        }
      }]);

      return PopupToggle;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class) || _class);


    return PopupToggle;
  };
};


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withLayers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withGroupEvent__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withUID__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var layersMap = {};

var withLayers = function withLayers() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments[1];
  return __WEBPACK_IMPORTED_MODULE_1_recompose__["hoistStatics"](function (Component) {
    var _class, _temp;

    var WithLayers = (_temp = _class = function (_React$Component) {
      _inherits(WithLayers, _React$Component);

      function WithLayers(props, context) {
        _classCallCheck(this, WithLayers);

        var _this = _possibleConstructorReturn(this, (WithLayers.__proto__ || Object.getPrototypeOf(WithLayers)).call(this, props));

        _this.layersProps = {
          isFirst: function isFirst() {
            return layersMap[key].length === 1;
          },
          isTop: function isTop() {
            return layersMap[key].indexOf(_this.props.UID) === layersMap[key].length - 1;
          },
          isEmpty: function isEmpty() {
            return layersMap[key].length === 0;
          }
        };

        _this.handlerOtherLayerUnmount = function () {
          return _this.setState({ index: layersMap[key].indexOf(_this.props.UID) });
        };

        layersMap = context.startlibs.__withLayers__internal = context.startlibs.__withLayers__internal || {};
        layersMap[key] = (layersMap[key] || []).concat([_this.props.UID]);
        _this.state = { index: layersMap[key].length - 1 };
        return _this;
      }

      _createClass(WithLayers, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          if (layersMap[key].length === 1 && settings.onFirst) settings.onFirst();
          this.props.groupEvent.on('unmount', this.handlerOtherLayerUnmount);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this2 = this;

          layersMap[key] = layersMap[key].filter(function (i) {
            return i !== _this2.props.UID;
          });
          if (layersMap[key].length === 0 && settings.onEmpty) {
            settings.onEmpty();
          }
          this.props.groupEvent.emit('unmount');
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, this.props, { layerIndex: this.state.index, layers: this.layersProps }));
        }
      }]);

      return WithLayers;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.contextTypes = { startlibs: function startlibs() {
        return null;
      } }, _class.layers = function () {
      return layersMap[key].length;
    }, _temp);


    return __WEBPACK_IMPORTED_MODULE_1_recompose__["hoistStatics"](function (c) {
      return __WEBPACK_IMPORTED_MODULE_3__withUID__["a" /* withUID */](__WEBPACK_IMPORTED_MODULE_2__withGroupEvent__["a" /* withGroupEvent */](c));
    })(WithLayers);
  });
};

withLayers.contextTypes = { startlibs: function startlibs() {
    return null;
  } };

/***/ })
/******/ ]);
});
//# sourceMappingURL=hocs.js.map


//////////////////
// WEBPACK FOOTER
// ./~/startlibs/lib/hocs.js
// module id = 2
// module chunks = 4